<div class="push-admin">
  <ion-card>
    <ion-card-header>
      <ion-card-title>Push-értesítés az appra</ion-card-title>
      <ion-card-subtitle>
        Feljegyzésről és üzenetről értesítés megy a mobilalkalmazásba: a tanulónak és minden
        gondviselőjének (a testvérnek nem). Üzenetnél minden címzett megkapja. A küldés közvetlenül
        a Google-ön (Android) és az Apple-ön (iOS) át megy, közvetítő szolgáltató nélkül.
      </ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <ion-item lines="full">
        <ion-label>
          <h2>Push-értesítések küldése</h2>
          <p>Kikapcsolva semmi nem megy ki; az üzenet és a feljegyzés ettől függetlenül elkészül.</p>
        </ion-label>
        <ion-toggle slot="end" [(ngModel)]="b.enabled"></ion-toggle>
      </ion-item>

      <ion-grid>
        <ion-row>
          <ion-col size="12" sizeMd="6">
            <p class="allapot-sor" [class.van]="b.fcm">
              <b>Android:</b>
              <ng-container *ngIf="b.fcm; else nincsFcm"> működik (Firebase: {{ b.fcm.projekt }})</ng-container>
              <ng-template #nincsFcm> nincs kulcs – androidos eszközre nem megy értesítés.</ng-template>
            </p>
          </ion-col>
          <ion-col size="12" sizeMd="6">
            <p class="allapot-sor" [class.van]="b.apns">
              <b>iOS:</b>
              <ng-container *ngIf="b.apns; else nincsApns"> működik (Apple-kulcs: {{ b.apns.key_id }})</ng-container>
              <ng-template #nincsApns> nincs kulcs – iPhone-ra nem megy értesítés.</ng-template>
            </p>
          </ion-col>
          <ion-col size="12">
            <p class="halvany">A küldés kulcsai a rendszerbe vannak építve, itt nincs mit beállítani.</p>
          </ion-col>
          <ion-col size="12" class="gombok">
            <ion-button fill="outline" (click)="probaKuldes()" [disabled]="proba || (!b.fcm && !b.apns)">
              {{ proba ? 'Küldés…' : 'Próba a saját telefonomra' }}
            </ion-button>
            <ion-button (click)="mentes()" [disabled]="ment || betolt">{{ ment ? 'Mentés…' : 'Mentés' }}</ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>

      <p class="halvany">
        Regisztrált eszközök: <b>{{ b.android_db }}</b> Android, <b>{{ b.ios_db }}</b> iOS ({{ b.szemely_db }} felhasználó).
        Egy eszköz akkor kerül ide, amikor valaki belép a mobilalkalmazásba és engedélyezi az értesítéseket.
      </p>

      <h3 class="cim" *ngIf="b.naplo?.length">Legutóbbi küldések</h3>
      <table class="naplo" *ngIf="b.naplo?.length">
        <thead><tr><th>Idő</th><th>Miről</th><th>Személy</th><th>Eszköz</th><th>Sikeres</th><th>Hiba</th></tr></thead>
        <tbody>
          <tr *ngFor="let n of b.naplo" [class.hibas]="n.hiba">
            <td>{{ n.ido }}</td><td>{{ forrasNev[n.forras] || n.forras }}</td>
            <td class="szam">{{ n.szemely_db }}</td><td class="szam">{{ n.eszkoz_db }}</td>
            <td class="szam">{{ n.kuldes_id || '' }}</td><td>{{ n.hiba || '' }}</td>
          </tr>
        </tbody>
      </table>
    </ion-card-content>
  </ion-card>
</div>
